if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();

      // 1. Grab the checkbox
      this.checkbox = this.querySelector('.js-cart-terms-checkbox');

      // 2. Grab the form it targets (needs form="yourFormID" on the input)
      this.form = document.getElementById(this.checkbox.getAttribute('form'));

      // 3. Cache all checkout-ish buttons inside that form
 this.checkoutButtons = this.form.querySelectorAll(
  '[name="checkout"], .shopify-payment-button__button'
);

      // 4. Bind and attach listeners
      this.submitHandler = this.handleSubmit.bind(this);
      this.toggleButtons = this.updateButtons.bind(this);

      this.form.addEventListener('submit', this.submitHandler);
      this.checkbox.addEventListener('change', this.toggleButtons);
      document.addEventListener('gru:ltl-checkout-state', this.toggleButtons);

      // 5. Initialise state
      this.updateButtons();
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
      this.checkbox.removeEventListener('change', this.toggleButtons);
      document.removeEventListener('gru:ltl-checkout-state', this.toggleButtons);
    }

    handleSubmit(evt) {
      if (!this.checkbox.checked) {
        evt.preventDefault();
        alert(theme.strings.cartTermsConfirmation); // or your own text
      }
    }

    updateButtons() {
      const enable = this.checkbox.checked
        && !document.documentElement.classList.contains('gru-ltl-prequote-blocked');
      this.checkoutButtons.forEach(btn => {
        btn.disabled = !enable;
        btn.classList.toggle('disabled', !enable); // optional: add CSS opacity
      });
    }
  }

  customElements.define('cart-terms', CartTerms);
}